// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"loader_loader-wrapper__v-y5U","loader-content":"loader_loader-content__0gf4Z"};